module.exports = __webpack_public_path__ + "img/logo22.dc6ffe49.png";